import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaSearch } from "react-icons/fa";
import Background from './Background';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

function ChatList() {

    const [cookies, setCookie] = useCookies(['user']);
    const [chatList,setChatList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getChatList = () => {
        var data = new FormData();
        
        data.append("user_id",11);
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_chats', {
            method: 'POST',
            body: data
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
               setChatList(data.data);
            } else if(data.response_code == 404) {
                setChatList([]);
            }
         });
    }

    useEffect(() => {
        const abortController = new AbortController();
        getChatList();
       },[]);

    return(
        <div className="content">
            <div className="row justify-content-start">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 className="heading" style={{ color:"white", marginTop:"50px" }}>Chat List</h4>
                    
                    {/* Table */}
                    <div className="card" style={{ borderColor:"white" }}>
                        <div className="table-responsive">
                            <table style={{ width:"100%" }} className="table table-striped">
                                <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>#</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>NAME</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>EMAIL</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>MESSAGE</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>MOBILE</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        chatList.map((chat, i) => (
                                                <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {i+1}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {(chat.sender_id != 11) ? chat.sender.middle_name != null ? (chat.sender.first_name + " " + chat.sender.middle_name + " " + chat.sender.last_name) : "" : ""}
                                                        {(chat.sender_id != 11) ? chat.sender.middle_name == null ? (chat.sender.first_name + " " + chat.sender.last_name) : "" : ""}
                                                        {(chat.receiver_id != 11) ? chat.receiver.middle_name != null ? (chat.receiver.first_name + " " + chat.receiver.middle_name + " " + chat.receiver.last_name) : "" : ""}
                                                        {(chat.receiver_id != 11) ? chat.receiver.middle_name == null ? (chat.receiver.first_name + " " + chat.receiver.last_name) : "" : ""}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#666" }}>
                                                        {(chat.sender_id != 11) ? chat.sender.email : ""}
                                                        {(chat.receiver_id != 11) ? chat.receiver.email : ""}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {(chat.sender_id != 11) ? "Correspondent: "+chat.message : "You: "+chat.message}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {(chat.receiver_id != 11) ? chat.receiver.mobile || '-' : ''}
                                                    </td>
                                                    <td style={{ padding: "12px 8px" }}>
                                                        <Link 
                                                            to={`/chat_details/${chat.sender_id}/${chat.receiver_id}`}
                                                            style={{
                                                                color: "#007bff",
                                                                textDecoration: "none",
                                                                fontSize: "14px",
                                                                fontWeight: "500"
                                                            }}
                                                        >
                                                            View
                                                        </Link>
                                                    </td>
                                                </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChatList;